(function(angular) {
    'use strict';

    angular.module('aprima-core').factory('StrConvert', [
        '_',
        StrConvert,
    ]);

    function StrConvert(
        _
    ) {

        var service = {
            replaceNewLine: replaceNewLine,
        };

        return service;

        function replaceNewLine(str, newVal, oldVal) {
            if(!str || !_.isString(str)) {
                return str;
            }

            var valToReplace = _.isNil(oldVal) ? /(\r\n|\r|\n)/g : oldVal;
            var replacement = _.isNil(newVal) ? '<br>' : newVal;

            var result = str.replace(valToReplace, replacement);
            return result;
        }
    }
})(window.angular);
